import React, { useState } from 'react';
import Dropdown from 'react-bootstrap/Dropdown';
import Form from 'react-bootstrap/Form';
import PropTypes from 'prop-types';

const groupByProject = (repos) => {
  return repos.reduce((acc, repo) => {
    const project = repo.projectName || 'Unknown Project';
    if (!acc[project]) acc[project] = [];
    acc[project].push(repo);
    return acc;
  }, {});
};

const RepositoryMultiSelect = ({
  repositories,
  selectedRepositoryId,
  handleRepoSelection,
  handleSelectAll,
  handleProjectToggle,
  isAllSelected,
}) => {
  const [searchTerm, setSearchTerm] = useState('');
  const groupedRepos = groupByProject(repositories);

  // Filter repos based on search term
  const filteredGroupedRepos = Object.fromEntries(
    Object.entries(groupedRepos).map(([project, repos]) => [
      project,
      repos.filter(repo =>
        repo.name.toLowerCase().includes(searchTerm.toLowerCase())
      ),
    ]).filter(([_, repos]) => repos.length > 0)
  );

  return (
    <Dropdown className="repositories-multiselect-wrapper" autoClose="outside">
      <Dropdown.Toggle
        variant="select"
        id="dropdown-repo"
        style={{ width: '100%', height: '100%' }}
      >
        {selectedRepositoryId.length > 0
          ? `${selectedRepositoryId.length} selected`
          : 'Select Repositories'}
      </Dropdown.Toggle>

      <Dropdown.Menu
        style={{ maxHeight: '300px', width: '270px', overflowY: 'auto' }}
      >
        {/* Search Input */}
        <Form.Control
          type="text"
          placeholder="Search repositories..."
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          style={{ marginBottom: '10px' }}
        />

        <Form.Check
          type="checkbox"
          label="Select All"
          checked={isAllSelected}
          onChange={handleSelectAll}
        />
        <hr />

        {Object.entries(filteredGroupedRepos).map(([project, repos]) => {
          const allProjectReposSelected = repos.every((repo) =>
            selectedRepositoryId.includes(String(repo.ID))
          );

          return (
            <div key={project} style={{ marginBottom: '10px' }}>
              <Form.Check
                type="checkbox"
                label={<span style={{ fontWeight: 'bold' }}>{project}</span>}
                checked={allProjectReposSelected}
                onChange={() => handleProjectToggle(project, repos)}
              />
              <div style={{ marginLeft: '1rem' }}>
                {repos.map((repo) => (
                  <Form.Check
                    key={repo.ID}
                    type="checkbox"
                    label={repo.name}
                    value={repo.ID}
                    checked={selectedRepositoryId.includes(String(repo.ID))}
                    onChange={handleRepoSelection}
                  />
                ))}
              </div>
            </div>
          );
        })}
      </Dropdown.Menu>
    </Dropdown>
  );
};

RepositoryMultiSelect.propTypes = {
  repositories: PropTypes.array.isRequired,
  selectedRepositoryId: PropTypes.array.isRequired,
  handleRepoSelection: PropTypes.func.isRequired,
  handleSelectAll: PropTypes.func.isRequired,
  handleProjectToggle: PropTypes.func.isRequired,
  isAllSelected: PropTypes.bool.isRequired,
};

export default RepositoryMultiSelect;
